import { render, staticRenderFns } from "./MiniBannersComponent.vue?vue&type=template&id=571b46a2"
import script from "./MiniBannersComponent.vue?vue&type=script&lang=js"
export * from "./MiniBannersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports